import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import AppModal, { AppModalProps } from "../../Modals/AppModal";
import AppModalTitle from "../../Modals/AppModalTitle";
import VehicleScheduleEntryCreate, {
  VehicleScheduleEntryCreateProps,
} from "./VehicleScheduleEntryCreate";

export interface OwnProps {
  createProps: VehicleScheduleEntryCreateProps;
}
type Props = OwnProps & AppModalProps;

export function VehicleScheduleEntryCreateModal({ createProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalTitle
        title={"Create schedule entry"}
        withClose
        onClose={() => modalProps.onClose?.({}, "backdropClick")}
      />
      <AppModalContent>
        {openStatus.isOpen && (
          <VehicleScheduleEntryCreate
            {...createProps}
            onCancel={() => {
              modalProps.onClose?.({}, "backdropClick");
              createProps.onCancel();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
